module.exports = {"id":"dp4_2l3q2","text":"Protecting personal data and privacy","instructions":"Which term describes personal data that cannot identify an individual directly?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.2","questionType":"PickOne","random":true,"options":[{"id":"dp4_2l3q2-a1","text":"Pseudonymisation","score":3.7},{"id":"dp4_2l3q2-a2","text":"Encryption","score":1.3},{"id":"dp4_2l3q2-a3","text":"Aggregation","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.2/l3q2.json
// module id = 1229
// module chunks = 41